import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../utils/Enums";
import {
    deleteService,
    getCurrentService,
    resetDeleteServiceStatus
} from "../../store/reducers/ServicesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import { LoggedInView } from "../common/LoggedInView";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";

interface DeleteServiceScreenProps {
}

export const DeleteServiceScreen: React.FC<DeleteServiceScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const servicesState = useAppSelector(state => state.services);
    const requestStatus: RequestStatus = servicesState.deleteServiceStatus;

    const { id } = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: 'Teenused', url: '/services' },
        { text: 'Teenuse kustutamine', url: '/services/delete' },
    ];

    useEffect(() => {
        dispatch(resetDeleteServiceStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteService({ id }));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentService({ id }));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Teenus kustutatud</h2>
                </div>
            </div>
        )
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{ textAlign: 'center' }}>
                <div>
                    <h2>
                        Kas oled kindel, et soovid teenuse {' '}
                        <em>{servicesState?.currentService?.name ?? ''}</em> kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes" />
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );

}